import React from 'react';
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { GripVertical, FormInput } from 'lucide-react';

export const Placeholder = Node.create({
  name: 'placeholder',

  group: 'inline',
  inline: true,
  atom: false,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      id: { default: null },
      key: { default: 'email' },
      label: { default: 'Enter email' },
      value: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-placeholder]' }];
  },

  renderHTML({ node }) {
    const display = node.attrs.value || node.attrs.label;

    return [
      'span',
      mergeAttributes({
        'data-placeholder': node.attrs.key,
        class:
          'inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-[#EEF1FD] border border-[#375AE7]/20 text-[#375AE7] text-sm font-semibold cursor-pointer',
        contenteditable: 'false',
      }),
      display,
    ];
  },

  addCommands() {
    return {
      insertPlaceholder:
        (attrs) =>
        ({ commands }) => {
          return commands.insertContent([
            {
              type: this.name,
              attrs,
            },
            {
              type: 'text',
              text: ' ',
            },
          ]);
        },
    };
  },
});

function PlaceholderView({ node, getPos }) {
  const onDragStart = (e) => {
    try {
      const from = typeof getPos === 'function' ? getPos() : null;
      const payload = JSON.stringify({
        type: 'editor-drag',
        nodeType: 'placeholder',
        from,
        key: node.attrs.key,
        label: node.attrs.label,
      });
      e.dataTransfer.setData('application/x-rp-editor', payload);
      e.dataTransfer.setData('text/plain', payload);
      e.dataTransfer.effectAllowed = 'move';
      console.debug('[NodeView] placeholder dragstart', payload);
    } catch (err) {
      console.log('error' + err.message);
    }
  };

  return (
    <NodeViewWrapper
      as="span"
      data-placeholder={node.attrs.key}
      contentEditable={false}
      className="inline-flex items-center align-middle my-0.5"
    >
      <span
        className="
          inline-flex items-center gap-1.5 rounded-lg
          border border-[#375AE7]/25 bg-gradient-to-r from-[#EEF1FD] to-[#F5F7FE]
          px-2 py-1 text-sm font-semibold text-[#375AE7]
          shadow-sm transition-all
          hover:border-[#375AE7]/40 hover:shadow-md
        "
        draggable
        onDragStart={onDragStart}
      >
        <span
          onMouseDown={(e) => e.preventDefault()}
          draggable
          onDragStart={onDragStart}
          className="cursor-grab text-[#375AE7]/40 hover:text-[#375AE7] transition-colors"
          aria-hidden
        >
          <GripVertical className="h-3.5 w-3.5" />
        </span>

        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-[#375AE7]/10 ring-1 ring-[#375AE7]/15">
          <FormInput className="h-3 w-3" strokeWidth={2.25} />
        </span>

        <span className="cursor-text px-0.5">
          {node.attrs.value || node.attrs.label}
        </span>
      </span>
    </NodeViewWrapper>
  );
}

Placeholder.addNodeView = function () {
  return ReactNodeViewRenderer(PlaceholderView);
};
